<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import storage from "./api/storage";
export default {
  data() {
    return {};
  },
  created() {
  },
  watch: {
    $route: {
      handler: function (to, from) {
        // console.log(to, from);
        if (
          // (to.path != "/productsXq" &&
          //   to.path != "/products" &&
          //   to.path != "/ycProducts" &&
          //   to.path != "/other" &&
          //   from.path != "/productsXq" &&
          //   from.path != "/products" &&
          //   from.path != "/other" &&
          //   from.path != "/ycProducts") ||
          from.path == "/"
        ) {
          // storage.removedataList();
          // storage.removeList();
          // storage.removeLists();
        }
        // if (
        //   // (to.path != "/mergingCoil" &&
        //   //   to.path != "/mergingCoilDetail" &&
        //   //   to.path != "/cpDefect" &&
        //   //   from.path != "/mergingCoil" &&
        //   //   from.path != "/mergingCoilDetail" &&
        //   //   from.path != "/cpDefect") ||
        //   from.path == "/"
        // ) {
        //   storage.removeList();
        // }
        // if (
        //   (to.path != "/cpIntoStoreDetail" &&
        //     to.path != "/cpIntoStore" &&
        //     from.path != "/cpIntoStoreDetail" &&
        //     from.path != "/cpIntoStore") ||
        //   from.path == "/"
        // ) {
        //   storage.removeLists();
        // }
      },
    },
  },
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  height: 100%;
  width: 100%;
}
html,
body {
  // background-color: #ddd;
}
</style>
